import { useEffect, useState } from 'react';
import {
  getDay,
  isFriday,
  isMonday,
  isSaturday,
  isSunday,
  isThursday,
  isTuesday,
  isWednesday,
  nextFriday,
  nextMonday,
  nextSaturday,
  nextSunday,
  nextThursday,
  nextTuesday,
  nextWednesday,
  previousFriday,
  previousMonday,
  previousSaturday,
  previousSunday,
  previousThursday,
  previousTuesday,
  previousWednesday,
} from 'date-fns';
import Button from '../../Button';

function RecurrencePopup({
  handleRecurClose = () => {},
  appDate,
  handleAppDate = () => {},
  handleRecurranceFormData,
  recurData = {},
  taskDiv = false,
}) {
  let recType = 1;
  if (recurData?.recurrence_type && recurData?.recurrence_type === '0') {
    recType = 1;
  } else if (recurData?.recurrence_type && recurData?.recurrence_type === '1') {
    recType = 2;
  } else if (recurData?.recurrence_type && recurData?.recurrence_type === '2') {
    recType = 3;
  }

  const [period, setPeriod] = useState(recType || 1);

  //period 1
  const [weeklyRecurValue, setWeeklyRecurValue] = useState(
    recurData?.recur_every || null,
  );

  let recurEveryWeekOn =
    recurData?.recur_every_week_on && recurData?.recur_every_week_on.split(',');

  const [weekDays, setWeekDays] = useState(recurEveryWeekOn || []);

  //period 2
  const [monthOpt, setMonthOpt] = useState(recurData?.monthly_mode || '0');
  //monthOpt===0
  const [monOptDay, setMonOptDay] = useState(recurData?.days || '');
  const [monOptMon, setMonOptMon] = useState(recurData?.every_month || '');
  //monthOpt===1
  const [montOptWeek, setMontOptWeek] = useState(recurData?.other_type || '');
  const [montOptOcrDay, setMontOptOcrDay] = useState(
    recurData?.other_day || '',
  );
  const [montOptOcrInpt, setMontOptOcrInpt] = useState(
    recurData?.other_every_month || '',
  );

  //period 3

  const [yearOptWeek, setYearOptWeek] = useState(recurData?.recur_every || '');
  let yearMode = 0;
  if (recurData?.year_mode === '0') {
    yearMode = 0;
  } else if (recurData?.year_mode === '1') {
    yearMode = 1;
  }
  const [yearOpt, setYearOpt] = useState(yearMode || 0);
  //yearOpt===0
  const [yearOptOcr, setYearOptOcr] = useState(recurData?.on_value || '');
  const [yearOptOcrYear, setYearOptOcrYear] = useState(
    recurData?.on_month || '',
  );

  //yearOpt===1
  const [yearOptOcrFild, setYearOptOcrFild] = useState(
    recurData?.on_the_type || '',
  );
  const [yearOptOcrWeekFild, setYearOptOcrWeekFild] = useState(
    recurData?.on_the_day_name || '',
  );
  const [yearOptOcrMonFild, setYearOptOcrMonFild] = useState(
    recurData?.on_the_month_name || '',
  );

  const [occurEndAfter, setOccurEndAfter] = useState(
    recurData?.range_after || '',
  );

  useEffect(() => {
    if (recurData && Object.keys(recurData).length > 0) {
      let recType = 1;
      if (recurData?.recurrence_type === '0') {
        recType = 1;
      } else if (recurData?.recurrence_type === '1') {
        recType = 2;
      } else if (recurData?.recurrence_type === '2') {
        recType = 3;
      }
      setPeriod(recType);

      // Period 1 (Weekly)
      setWeeklyRecurValue(recurData?.recur_every || '');
      setWeekDays(recurData?.recur_every_week_on ? recurData?.recur_every_week_on.split(',') : []);

      // Period 2 (Monthly)
      setMonthOpt(recurData?.monthly_mode || '0');
      setMonOptDay(recurData?.days || '');
      setMonOptMon(recurData?.every_month || '');
      setMontOptWeek(recurData?.other_type || '');
      setMontOptOcrDay(recurData?.other_day || '');
      setMontOptOcrInpt(recurData?.other_every_month || '');

      // Period 3 (Yearly)
      setYearOptWeek(recurData?.recur_every || '');
      setYearOpt(recurData?.year_mode === '1' ? 1 : 0);
      setYearOptOcr(recurData?.on_value || '');
      setYearOptOcrYear(recurData?.on_month || '');
      setYearOptOcrFild(recurData?.on_the_type || '');
      setYearOptOcrWeekFild(recurData?.on_the_day_name || '');
      setYearOptOcrMonFild(recurData?.on_the_month_name || '');

      // Range
      setOccurEndAfter(recurData?.range_after || '');
    }
  }, [recurData]);

  const handlePeriod = (type) => {
    setPeriod(type);
    if (type === 1) {
      setMonthOpt('0');
      setMonOptDay('');
      setMonOptMon('');
      setMontOptWeek('');
      setMontOptOcrDay('');
      setMontOptOcrInpt('');

      setYearOpt(0);
      setYearOptWeek('');
      setYearOptOcr('');
      setYearOptOcrYear('');
      setYearOptOcrFild('');
      setYearOptOcrWeekFild('');
      setYearOptOcrMonFild('');
    } else if (type === 2) {
      setWeekDays([]);
      setWeeklyRecurValue('');

      setYearOpt(0);
      setYearOptWeek('');
      setYearOptOcr('');
      setYearOptOcrYear('');
      setYearOptOcrFild('');
      setYearOptOcrWeekFild('');
      setYearOptOcrMonFild('');
    } else if (type === 3) {
      setWeekDays([]);
      setWeeklyRecurValue('');

      setMonthOpt('0');
      setMonOptDay('');
      setMonOptMon('');
      setMontOptWeek('');
      setMontOptOcrDay('');
      setMontOptOcrInpt('');
    }
    setOccurEndAfter('');
  };

  const handleweekDaysCheckBox = (e) => {
    const { value, checked, dataset } = e.target;
    if (checked) {
      setWeekDays([...weekDays, value]);
    } else {
      setWeekDays(weekDays.filter((e) => e !== value));
    }

    if (!appDate) {
      if (checked) {
        handleAppDate(new Date(dataset.daydt));
      }
    } else if (
      (appDate && weekDays.length === 0) ||
      isMonday(new Date(dataset.daydt))
    ) {
      handleAppDate(new Date(dataset.daydt));
    }
  };

  useEffect(() => {
    const recArr = {};
    if (period === 1) {
      recArr['occur_type'] = '0';
      recArr['recur_value'] = parseInt(weeklyRecurValue) || '';
      recArr['chckMon'] = weekDays.find((d) => parseInt(d) === 1) ? 1 : 0;
      recArr['chckTue'] = weekDays.find((d) => parseInt(d) === 2) ? 1 : 0;
      recArr['chckWed'] = weekDays.find((d) => parseInt(d) === 3) ? 1 : 0;
      recArr['chckThu'] = weekDays.find((d) => parseInt(d) === 4) ? 1 : 0;
      recArr['chckFri'] = weekDays.find((d) => parseInt(d) === 5) ? 1 : 0;
      recArr['chckSat'] = weekDays.find((d) => parseInt(d) === 6) ? 1 : 0;
      recArr['chckSun'] = weekDays.find((d) => parseInt(d) === 0) ? 1 : 0;
    } else if (period === 2) {
      recArr['occur_type'] = '1';
      recArr['sub_occur_type'] = monthOpt === '0' ? '0' : '1';

      if (monthOpt === '0') {
        recArr['monthly_day'] = monOptDay;
        recArr['recur_value'] = monOptMon;

        setMontOptWeek('');
        setMontOptOcrDay('');
        setMontOptOcrInpt('');
      } else {
        recArr['week_day'] = montOptWeek;
        recArr['monthly_day'] = montOptOcrDay;
        recArr['recur_value'] = montOptOcrInpt;

        setMonOptDay('');
        setMonOptMon('');
      }
    } else if (period === 3) {
      recArr['occur_type'] = '2';
      recArr['recur_value'] = yearOptWeek;
      recArr['sub_occur_type'] = yearOpt === 0 ? '0' : '1';
      if (yearOpt === 0) {
        recArr['yearly_day'] = yearOptOcr;
        recArr['yearly_month'] = yearOptOcrYear;

        setYearOptOcrFild('');
        setYearOptOcrWeekFild('');
        setYearOptOcrMonFild('');
      } else {
        recArr['week_day'] = yearOptOcrFild;
        recArr['yearly_day'] = yearOptOcrWeekFild;
        recArr['yearly_month'] = yearOptOcrMonFild;

        setYearOptOcr('');
        setYearOptOcrYear('');
      }
    }
    recArr['occur_end_after'] = occurEndAfter;
    handleRecurranceFormData(recArr);
  }, [
    period,
    weeklyRecurValue,
    weekDays,
    occurEndAfter,
    monthOpt,
    monOptDay,
    monOptMon,
    montOptWeek,
    yearOpt,
    montOptOcrDay,
    yearOptOcrMonFild,
    montOptOcrInpt,
    yearOptOcrFild,
    yearOptOcrWeekFild,
    yearOptOcrYear,
    yearOptWeek,
    yearOptOcr,
    handleRecurranceFormData,
  ]);

  const style = {
    left: 'unset',
    top: 'unset',
    width: '100%',
    position: 'unset',
    boxShadow: 'unset',
  };

  return (
    <div className="app-recurrence" style={taskDiv ? style : {}}>
      {!taskDiv && (
        <div className="app-recurrence-head">
          <span className="app-recurrence-head-heading">
            Recurrence Pattern
          </span>
          <Button
            className="app-recurrence-head-close"
            variant="circle"
            onClick={handleRecurClose}
          >
            X
          </Button>
        </div>
      )}
      <div className="app-recurrence-period">
        <span className="app-recurrence-period-inputs">
          <input
            type="radio"
            name="recurenceRadio"
            style={{ marginRight: '10px' }}
            checked={period === 1 ? true : false}
            value={period}
            onChange={() => handlePeriod(1)}
          />
          <span className="ocurenc-radio">Weekly</span>
        </span>

        <span className="app-recurrence-period-inputs">
          <input
            type="radio"
            name="recurenceRadio"
            style={{ marginRight: '10px' }}
            checked={period === 2 ? true : false}
            value={period}
            onChange={() => handlePeriod(2)}
          />
          <span className="ocurenc-radio">Monthly</span>
        </span>

        <span className="app-recurrence-period-inputs">
          <input
            type="radio"
            name="recurenceRadio"
            style={{ marginRight: '10px' }}
            checked={period === 3 ? true : false}
            value={period}
            onChange={() => handlePeriod(3)}
          />
          <span className="ocurenc-radio">Yearly</span>
        </span>
      </div>
      {period === 1 && (
        <div className="app-recurrence-period-week">
          <div className="app-recurrence-period-week-row">
            <span className="app-recurrence-period-week-row-lable">
              Recur every:
            </span>
            <input
              type="number"
              className="ocurnc-week-field"
              name="weekly_recur_value"
              min={1}
              value={weeklyRecurValue || ''}
              onChange={(e) => setWeeklyRecurValue(e.target.value)}
            />
            <span className="app-recurrence-period-week-row-lable">
              week(s) on
            </span>
          </div>
          <div className="app-recurrence-period-week-row">
            <span className="app-recurrence-period-week-radio">
              <input
                type="Checkbox"
                value="1"
                style={{ marginRight: '5px' }}
                onChange={handleweekDaysCheckBox}
                data-daydt={
                  isMonday(new Date())
                    ? new Date()
                    : getDay(new Date()) > 1
                      ? nextMonday(new Date())
                      : previousMonday(new Date())
                }
                checked={weekDays.some((d) => parseInt(d) === 1)}
              />
              <span className="ocurenc-radio">Monday</span>
            </span>

            <span className="app-recurrence-period-week-radio">
              <input
                type="Checkbox"
                value="2"
                style={{ marginRight: '5px' }}
                onChange={handleweekDaysCheckBox}
                data-daydt={
                  isTuesday(new Date())
                    ? new Date()
                    : getDay(new Date()) > 1
                      ? nextTuesday(new Date())
                      : previousTuesday(new Date())
                }
                checked={weekDays.some((d) => parseInt(d) === 2)}
              />
              <span className="ocurenc-radio">Tuesday</span>
            </span>

            <span className="app-recurrence-period-week-radio">
              <input
                type="Checkbox"
                value="3"
                style={{ marginRight: '5px' }}
                onChange={handleweekDaysCheckBox}
                data-daydt={
                  isWednesday(new Date())
                    ? new Date()
                    : getDay(new Date()) > 1
                      ? nextWednesday(new Date())
                      : previousWednesday(new Date())
                }
                checked={weekDays.some((d) => parseInt(d) === 3)}
              />
              <span className="ocurenc-radio">Wednesday</span>
            </span>

            <span className="app-recurrence-period-week-radio">
              <input
                type="Checkbox"
                value="4"
                style={{ marginRight: '5px' }}
                onChange={handleweekDaysCheckBox}
                data-daydt={
                  isThursday(new Date())
                    ? new Date()
                    : getDay(new Date()) > 1
                      ? nextThursday(new Date())
                      : previousThursday(new Date())
                }
                checked={weekDays.some((d) => parseInt(d) === 4)}
              />
              <span className="ocurenc-radio">Thursday</span>
            </span>
          </div>
          <div className="app-recurrence-period-week-row">
            <span className="app-recurrence-period-week-radio">
              <input
                type="Checkbox"
                value="5"
                style={{ marginRight: '5px' }}
                onChange={handleweekDaysCheckBox}
                data-daydt={
                  isFriday(new Date())
                    ? new Date()
                    : getDay(new Date()) > 1
                      ? nextFriday(new Date())
                      : previousFriday(new Date())
                }
                checked={weekDays.some((d) => parseInt(d) === 5)}
              />
              <span className="ocurenc-radio">Friday</span>
            </span>

            <span className="app-recurrence-period-week-radio">
              <input
                type="Checkbox"
                value="6"
                style={{ marginRight: '5px' }}
                onChange={handleweekDaysCheckBox}
                data-daydt={
                  isSaturday(new Date())
                    ? new Date()
                    : getDay(new Date()) > 1
                      ? nextSaturday(new Date())
                      : previousSaturday(new Date())
                }
                checked={weekDays.some((d) => parseInt(d) === 6)}
              />
              <span className="ocurenc-radio">Saturday</span>
            </span>

            <span className="app-recurrence-period-week-radio">
              <input
                type="Checkbox"
                value="0"
                style={{ marginRight: '5px' }}
                onChange={handleweekDaysCheckBox}
                data-daydt={
                  isSunday(new Date())
                    ? new Date()
                    : getDay(new Date()) > 1
                      ? nextSunday(new Date())
                      : previousSunday(new Date())
                }
                checked={weekDays.some((d) => parseInt(d) === 0)}
              />
              <span className="ocurenc-radio">Sunday</span>
            </span>
          </div>
        </div>
      )}

      {period === 2 && (
        <div className="app-recurrence-period-week">
          <div className="occurence-main-bdy-rw">
            <span style={{ marginRight: '5px' }}>
              <input
                type="radio"
                name="monthly_option_select"
                style={{ marginRight: '5px' }}
                value={monthOpt}
                checked={monthOpt === '0' ? true : false}
                onChange={(e) => setMonthOpt('0')}
              />
              <span className="recur-text-mnth">Days</span>
            </span>
            <input
              type="number"
              min={1}
              value={monOptDay}
              style={{
                width: '60px',
                margin: '0 5px',
                color: 'rgb(68, 68, 68)',
                fontSize: '11px',
                padding: ' 0px 6px',
                height: '25px',
              }}
              className="ocurnc-week-field"
              onChange={(e) => setMonOptDay(e.target.value)}
            />
            <span className="ocurenc-radio ocrnc-year-text">of every</span>
            <input
              type="number"
              min={1}
              value={monOptMon}
              style={{
                width: '60px',
                margin: '0 5px',
                color: 'rgb(68, 68, 68)',
                fontSize: '11px',
                padding: ' 0px 6px',
                height: '25px',
              }}
              className="ocurnc-week-field"
              onChange={(e) => setMonOptMon(e.target.value)}
            />
            <span className="ocurenc-radio ocrnc-year-text">Months(s)</span>
          </div>
          <div className="occurence-main-bdy-rw">
            <span style={{ marginRight: '15px', display: 'flex' }}>
              <input
                type="radio"
                name="monthly_option_select"
                style={{ marginRight: '5px' }}
                value={monthOpt}
                checked={monthOpt === '1' ? true : false}
                onChange={(e) => setMonthOpt('1')}
              />
              <span className="recur-text-mnth">The</span>
            </span>
            <span className="left styl-scheduler-3">
              <select
                style={{
                  width: '60px',
                  marginRight: '10px',
                  color: 'rgb(68, 68, 68)',
                  fontSize: '11px',
                  padding: ' 0px 6px',
                  height: '25px',
                }}
                className="ocurnc-week-field"
                value={montOptWeek}
                onChange={(e) => setMontOptWeek(e.target.value)}
              >
                <option value=""></option>
                <option value="First">First</option>
                <option value="Second">Second</option>
                <option value="Third">Third</option>
                <option value="Fourth">Fourth</option>
                <option value="Last">Last</option>
              </select>
              <select
                style={{
                  width: '105px',
                  color: 'rgb(68, 68, 68)',
                  fontSize: '11px',
                  padding: ' 0px 6px',
                  height: '25px',
                }}
                className="ocurnc-week-field"
                value={montOptOcrDay}
                onChange={(e) => setMontOptOcrDay(e.target.value)}
              >
                <option value=""></option>
                <option value="1">Monday</option>
                <option value="2">Tuesday</option>
                <option value="3">Wednesday</option>
                <option value="4">Thursday</option>
                <option value="5">Friday</option>
                <option value="6">Saturday</option>
                <option value="0">Sunday</option>
              </select>
              <span style={{ margin: '0 5px' }}>of every</span>
              <input
                type="number"
                min={1}
                style={{
                  width: '60px',
                  margin: '0 5px',
                  color: 'rgb(68, 68, 68)',
                  fontSize: '11px',
                  padding: ' 0px 6px',
                  height: '25px',
                }}
                className="ocurnc-week-field"
                value={montOptOcrInpt}
                onChange={(e) => setMontOptOcrInpt(e.target.value)}
              />
              <span className="ocurenc-radio ocrnc-year-text">Months(s)</span>
            </span>
          </div>
        </div>
      )}

      {period === 3 && (
        <div className="app-recurrence-period-week">
          <div className="occurence-main-bdy-rw">
            <div className="app-recurrence-period-week-row">
              <span className="app-recurrence-period-week-row-lable">
                Recur every:
              </span>
              <input
                type="number"
                className="ocurnc-week-field"
                name="weekly_recur_value"
                style={{
                  marginRight: '10px',
                  color: '#444444',
                  float: 'left',
                  fontSize: '11px',
                  padding: '0 6px',
                  width: '61px ',
                  height: '25px',
                }}
                value={yearOptWeek}
                onChange={(e) => setYearOptWeek(e.target.value)}
              />
              <span className="app-recurrence-period-week-row-lable">
                week(s) on
              </span>
            </div>
          </div>
          <div className="occurence-main-bdy-rw">
            <span
              style={{
                marginRight: '44px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <input
                type="radio"
                name="yearly_option_select"
                value={yearOpt}
                checked={yearOpt === 0 ? true : false}
                onChange={(e) => setYearOpt(0)}
                style={{ marginRight: '5px' }}
              />
              <span className="recur-text-mnth">On</span>
            </span>
            <span className="occurence-val">
              <input
                type="number"
                min={1}
                style={{
                  width: '100px',
                  marginRight: '10px',
                  color: 'rgb(68, 68, 68)',
                  fontSize: '11px',
                  padding: '0px 6px',
                  height: '25px',
                }}
                className="ocurnc-week-field"
                value={yearOptOcr}
                onChange={(e) => setYearOptOcr(e.target.value)}
              />
              <select
                style={{
                  color: 'rgb(68, 68, 68)',
                  fontSize: '11px',
                  padding: '0px 6px',
                  height: '25px',
                }}
                className="ocurnc-week-field"
                value={yearOptOcrYear}
                onChange={(e) => setYearOptOcrYear(e.target.value)}
              >
                <option value=""></option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>
            </span>
          </div>
          <div className="occurence-main-bdy-rw">
            <span
              style={{
                marginRight: '19px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <input
                type="radio"
                name="yearly_option_select"
                style={{ marginRight: '5px' }}
                value={yearOpt}
                checked={yearOpt === 1 ? true : false}
                onChange={(e) => setYearOpt(1)}
              />
              <span className="recur-text-mnth">On the</span>
            </span>
            <select
              style={{
                width: '100px',
                color: 'rgb(68, 68, 68)',
                fontSize: '11px',
                padding: '0px 6px',
                height: '25px',
                marginRight: '10px',
              }}
              className="ocurnc-week-field"
              value={yearOptOcrFild}
              onChange={(e) => setYearOptOcrFild(e.target.value)}
            >
              <option value=""></option>
              <option value="First">First</option>
              <option value="Second">Second</option>
              <option value="Third">Third</option>
              <option value="Fourth">Fourth</option>
              <option value="Last">Last</option>
            </select>
            <select
              style={{
                width: '90px',
                color: 'rgb(68, 68, 68)',
                fontSize: '11px',
                padding: '0px 6px',
                height: '25px',
              }}
              className="ocurnc-week-field"
              value={yearOptOcrWeekFild}
              onChange={(e) => setYearOptOcrWeekFild(e.target.value)}
            >
              <option value=""></option>
              <option value="1">Monday</option>
              <option value="2">Tuesday</option>
              <option value="3">Wednesday</option>
              <option value="4">Thursday</option>
              <option value="5">Friday</option>
              <option value="6">Saturday</option>
              <option value="0">Sunday</option>
            </select>
            <span style={{ margin: '0 10px' }}> of</span>
            <select
              style={{
                color: 'rgb(68, 68, 68)',
                fontSize: '11px',
                padding: '0px 6px',
                height: '25px',
              }}
              className="ocurnc-week-field"
              value={yearOptOcrMonFild}
              onChange={(e) => setYearOptOcrMonFild(e.target.value)}
            >
              <option value=""></option>
              <option value="1">January</option>
              <option value="2">February</option>
              <option value="3">March</option>
              <option value="4">April</option>
              <option value="5">May</option>
              <option value="6">June</option>
              <option value="7">July</option>
              <option value="8">August</option>
              <option value="9">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </select>
          </div>
        </div>
      )}

      <div className="app-recurrence-foot">
        <div
          className="app-recurrence-foot-row"
          style={{ flexDirection: 'column' }}
        >
          <span style={{ borderBottom: '1px dotted #000', width: '100%' }}>
            &nbsp;
          </span>
          <span
            className="ocurrence-heading"
            style={{
              marginTop: '-8px',
              marginLeft: '15px',
              backgroundColor: '#fbfcf2',
              width: '115px',
            }}
          >
            Range of recurrence
          </span>
        </div>
        <div
          className="app-recurrence-foot-row"
          style={{ alignItems: 'center' }}
        >
          <span style={{ marginRight: '5px', marginLeft: '15px' }}>
            End after:<span className="required-fld">*</span>
          </span>
          <input
            type="number"
            className="ocurnc-week-field"
            name="occur_end_after"
            id="occur_end_after"
            min={1}
            value={occurEndAfter}
            style={{
              marginRight: '10px',
              color: '#444444',
              float: 'left',
              fontSize: '11px',
              padding: '0 6px',
              width: '61px ',
              height: '25px',
            }}
            onChange={(e) => setOccurEndAfter(e.target.value)}
          />
          <span className="ocurenc-radio">Occurrences</span>
        </div>
      </div>
    </div>
  );
}

export default RecurrencePopup;
